import { useEffect, useState } from "react";
import { Menu } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const links = [
  { label: "Manifesto", href: "#manifesto" },
  { label: "Sounds", href: "#sounds" },
  { label: "Itinerary", href: "#itinerary" },
  { label: "The Manor", href: "#venue" },
  { label: "Rates", href: "#rates" },
  { label: "FAQ", href: "#faq" },
];

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="nav-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,padding] duration-500 ${
        scrolled
          ? "bg-manor-bg/70 backdrop-blur-xl border-b border-white/10 py-4"
          : "bg-transparent border-b border-transparent py-6"
      }`}
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => go("#top")}
          className="flex items-center text-left leading-none"
        >
          <img
            src="https://customer-assets-cm19k8pv.emergentagent.net/job_manor-retreat/artifacts/gqh6m156_tmh%20circle%20logo.jpeg"
            alt="TMH Circle — The Mindful Human"
            className="h-11 w-auto rounded-md bg-manor-text px-2 py-1 md:h-12"
          />
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              onClick={() => go(l.href)}
              className="link-underline font-mono text-xs tracking-[0.2em] uppercase text-manor-sage hover:text-manor-text transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="nav-cta-reserve"
            onClick={() => go("#reserve")}
            className="hidden sm:inline-flex items-center rounded-full border border-manor-rust bg-manor-rust px-6 py-2.5 font-mono text-xs tracking-[0.2em] uppercase text-manor-bg hover:bg-transparent hover:text-manor-rust transition-colors duration-300"
          >
            Reserve
          </button>

          <div className="md:hidden">
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <button
                  data-testid="mobile-menu-trigger"
                  aria-label="Open menu"
                  className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-manor-text"
                >
                  <Menu className="h-5 w-5" />
                </button>
              </DropdownMenuTrigger>
              <DropdownMenuContent
                align="end"
                className="bg-manor-surface border border-white/10 text-manor-text"
              >
                {links.map((l) => (
                  <DropdownMenuItem
                    key={l.href}
                    data-testid={`mobile-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                    onClick={() => go(l.href)}
                    className="font-mono text-xs tracking-[0.15em] uppercase text-manor-sage focus:bg-white/5 focus:text-manor-text cursor-pointer"
                  >
                    {l.label}
                  </DropdownMenuItem>
                ))}
                <DropdownMenuItem
                  data-testid="mobile-link-reserve"
                  onClick={() => go("#reserve")}
                  className="font-mono text-xs tracking-[0.15em] uppercase text-manor-rust focus:bg-white/5 cursor-pointer"
                >
                  Reserve
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Nav;
